import FreebieCoverUrl from 'assets/images/la-Freebie-cover.jpg'
import { Col, Container, Row, Section } from 'atoms'
import Image from 'next/image'
import { ContactCard } from 'organisms'
import { FC } from 'react'
import { BsFileEarmarkPdf } from 'react-icons/bs'

import Styles from './LAFahrplanSelbstliebe.module.sass'
import SendinblueContent from './SendinblueContent'

const LAFahrplanSelbstliebe: FC<unknown> = () => (
  <>
    <Section background="rose">
      <Container>
        <h1>
          Fahrplan Selbstliebe
        </h1>
        <p className="d-none d-sm-block text-md-center">
          LebensArt Akademie
        </p>
      </Container>
    </Section>
    <Section>
      <Container>
        <Row className='flex-row-reverse align-items-start'>
          <Col xs={12} lg={6} xl={5}>
            <SendinblueContent />
          </Col>
          <Col xs={12} lg={6} xl={7}>
            <h2>
              Hol dir jetzt den Schlüssel für deinen einfachen Start in die Selbstliebe!
            </h2>
            <div className={Styles.freebieWrapper}>
              <div className={Styles.freebieImageWrapper}>
                <Image
                  src={FreebieCoverUrl}
                  alt="LebensArt Akademie Freebie"
                />
              </div>
              <div className={Styles.badge}>
                <span>
                  <BsFileEarmarkPdf />
                </span>
                <p>
                  Erhalte einen kostenlosen Einstieg. Melde
                  dich ganz einfach an und du bekommste eine PDF per E-Mail von mir.
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <p>
          {`Ich bin Cordelia Schmidt und arbeite seit vielen Jahren als Coachin und Therapeutin. Dabei habe ich mich auf die Herausforderungen von Frauen in privaten und beruflichen Kontexten spezialisiert. So durfte ich bereits sehr viele Frauen auf ihrem Weg in die Selbstermächtigung begleiten.`}
        </p>
        <p>
          {`Starte jetzt gleich, beginne deine spannende Reise zu dir selbst. Geführt von einer Frau, die den Weg bereits gegangen ist.`}
        </p>
        <p>
          {`Die Lebenszufriedenheit und die Lebensbalance von Frauen sind mir ein besonderes Anliegen. Frauen haben das Recht auf eine gleichberechtigte Teilhabe in unserer Gesellschaft, auf ein glückliches und zufriedenes Leben.`}
        </p>
      </Container>
    </Section>
    <Section background="vintage">
      <Container>
        <ContactCard />
      </Container>
    </Section>
  </>
)

export default LAFahrplanSelbstliebe
